// Utilities
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

// Services
import { attendanceService } from "../../../../../Api/Services/AttendanceService";

// Types

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IAttendanceEmployeeManagerServiceResponse } from "../../../../attendance/types";

/**
 * Async thunk to fetch Assigned Manager.
 * Dispatches an API call to the leave service.
 */
export const fetchAssginedManagerToEmployee = createServiceAsyncThunk<
  IAttendanceEmployeeManagerServiceResponse,
  { id: string | number }
>(
  ACTION_NAMES.FETCH_ASSIGNED_MANAGER_TO_EMPLOYEE, // Action Name
  ({ id }: { id: string | number }) =>
    attendanceService.attendanceEmployeeManager(id), // API Call
  ERROR_MESSAGES.FETCH_ASSIGNED_MANAGER_TO_EMPLOYEE_FAILURE // Error Message
);

/**
 * Slice to manage the state for Assigned Manager.
 * Includes actions to clear errors and handle async states.
 */
const assignedManagerToEmployeeSlice = createGenericSlice<
  IAttendanceEmployeeManagerServiceResponse,
  { id: string | number }
>(
  SLICE_NAMES.ASSIGNED_MANAGER_TO_EMPLOYEE, // Name of the slice
  fetchAssginedManagerToEmployee // Async Thunk
);

// Export the actions for resetting error and assigned manager details
export const {
  clearError: clearAssignedManagerToEmployeeError,
  clearSuccessMessage: clearAssignedManagerToEmployeeSuccess,
} = assignedManagerToEmployeeSlice.actions;

// Export the reducer for use in the Redux store
export default assignedManagerToEmployeeSlice.reducer;
